import React, { useEffect, useMemo,useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import * as colors from "@mui/material/colors";
import { useSelector } from "react-redux";
import axios from "axios";
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import { RouteDetails } from "./routeDetail";
import { useTranslation } from 'react-i18next';
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import DirectionsBikeIcon from "@mui/icons-material/DirectionsBike";
import DirectionsWalkIcon from "@mui/icons-material/DirectionsWalk";

export const RouteResult = (props) => {
  const { t } = useTranslation();
    const {  coordinates } = useSelector(
        (state) => state.map
      );
      const { pathUrls } = useSelector((state) => state.direction);
      console.log("pathUrls",pathUrls)
      const [routeData, setRouteData] = useState();
      const [state, setState] = useState(false)
      const [speed1, setSpeed1] = useState()
      const [cost1,setCost1] = useState()

      const [speed2, setSpeed2] = useState()
      const [cost2,setCost2] = useState()
      const [speed3, setSpeed3] = useState()
      const [cost3,setCost3] = useState()
      const [feature1,setfeature1] = useState()
      const [feature2, setfeature2] = useState()
      const [feature3,setfeature3] = useState()

 useEffect(() => {
    var speed = 0;
      var speed1;
      var speed2;
      var speed3;
      var const1 = 0;
      var const2 = 0;
      var const3 = 0;
      var coordinate1x1;
      var coordinate2x2;
      var coordinate3x3;
      var coordinate1y1;
      var coordinate2y2;
      var coordinate3y3;
  if(props.path_datas.length != 0){
    
    
      if (props.activeInnerTab == "CAR") {
        speed = 60;
      } else if (props.activeInnerTab == "BIKE") {
        speed = 25;
      } else if (props.activeInnerTab == "WALK") {
        speed = 4;
      }
    
      var mid = props.path_datas.length / 2;
      mid = mid.toFixed(0);
    
      coordinate3x3 = props.path_datas[props.path_datas.length -1].geometry.coordinates[0][0];
      coordinate3y3 = props.path_datas[props.path_datas.length -1].geometry.coordinates[0][1];  
     
        coordinate2x2= props.path_datas[mid].geometry.coordinates[0][0];
        coordinate2y2 = props.path_datas[mid].geometry.coordinates[0][1];
     
        coordinate1x1 = props.path_datas[0].geometry.coordinates[0][0];
        coordinate1y1 = props.path_datas[0].geometry.coordinates[0][1];
       for (let i = 1; i < props.path_datas.length; i++) {
          const element = props.path_datas[i];
        if(element != []){
          var pathSeq = element.properties.path_id;
    
    
    
 if (pathSeq != "1") {
            setfeature2(element)
            const2 += element.properties.cost / 1000;
            speed2 = const2 / speed;
            speed2 = (speed2 * 60).toFixed(0);
            if (speed2 >= 60) {
              speed2 = speed2 / 60;
              var getDecimalVal = speed2.toString().indexOf(".");
              var decimalPart = speed2.toString().substring(getDecimalVal);
              const firstTwoNumbers = String(decimalPart).substring(0, 2);
              // speed2 = `${getDecimalVal}h and ${firstTwoNumbers}`;
             
               const hours = speed2.toFixed(0);       // Whole hours
                  const minutes = Math.round(speed2 % 60).toFixed(0);     // Remaining minutes
                  speed2 = `${hours}h and ${minutes}`;
            }
            setSpeed2(speed2)
    
          } else if (pathSeq == "1") {
            setfeature1(element)
            const1 += element.properties.cost / 1000;
            speed1 = const1 / speed;
            speed1 = (speed1 * 100).toFixed(0);
            if (speed1 >= 60) {
              speed1 = speed1 / 60;
              var getDecimalVal = speed1.toString().indexOf(".");
              var decimalPart = speed1.toString().substring(getDecimalVal + 1);
              const firstTwoNumbers = String(decimalPart).substring(0, 2);
              speed1 = `${getDecimalVal}h and ${firstTwoNumbers}`;
             
            }
            setSpeed1(speed1)
          }
        
      }}
      if(const1 < 1){
        const1 = const1 * 1000;
        const1 = Number(const1.toFixed(2)) + "m";
      }else{
        const1 = Number(const1.toFixed(2)) + "km";
      }
      if(const2 < 1){
        const2 = const2 * 1000;
        const2 = Number(const2.toFixed(2)) + "m"; 
      }else{
        const2 = Number(const2.toFixed(2)) + "km"; 
      }
     
         setCost1(const1)
         setCost2(const2)
         setCost3(const3)
    
  }
  },[props.path_datas,props.activeInnerTab])

  
  const card = (
    <React.Fragment>
      <CardContent style={{color:"green"}}>
        <Typography sx={{ fontSize: 15 }} color="text.secondary" gutterBottom>
        {t('FastestRoute')}
        </Typography>
        {props.activeInnerTab == "CAR" ? <Typography sx={{ fontSize: 15 }}> 
        <DirectionsBusIcon
                      sx={{ fontSize: "18px", color: colors.cyan[600] }}
                    />  <span>  {cost1},{speed1}min</span>  </Typography> :null}

        {props.activeInnerTab == "BIKE" ? <Typography sx={{ fontSize: 15 }}>
                    <DirectionsBikeIcon
                      sx={{ fontSize: "18px", color: colors.cyan[600] }}
                    />    <span>   {cost1},{speed1}min</span>
                    </Typography>:null}
       
       {props.activeInnerTab == "WALK" ? <Typography sx={{ fontSize: 15 }}>
                    <DirectionsWalkIcon
                      sx={{ fontSize: "18px", color: colors.cyan[600] }}
                    />  <span>  {cost1},{speed1}min</span>
                    </Typography>:null}
                   
        
        {/* {coordinates.sourceName} to {coordinates.targetName} <span style={{paddingRight:"40px",color:"#00acc1"}}>{cost1}km,{speed1}min</span> */}


      </CardContent>
      <CardActions>      
    <span  size="small" style={{color:"#00acc1"}} onClick={() => setState(true)}>{t('Details')}</span>
     
      </CardActions>
    </React.Fragment>
  );
  const secondCard = (
    <React.Fragment>
          <CardContent style={{color:"blue"}}>
        <Typography sx={{ fontSize: 15 }} color="text.secondary" gutterBottom>
        {t('Route')}
        </Typography>
        {props.activeInnerTab == "CAR" ? <Typography sx={{ fontSize: 15 }}> 
        <DirectionsBusIcon
                      sx={{ fontSize: "18px", color: colors.cyan[600] }}
                    />  <span>  {cost2},{speed2}min</span>  </Typography> :null}

        {props.activeInnerTab == "BIKE" ? <Typography sx={{ fontSize: 15 }}>
                    <DirectionsBikeIcon
                      sx={{ fontSize: "18px", color: colors.cyan[600] }}
                    />    <span>   {cost2},{speed2}min</span>
                    </Typography>:null}
       
       {props.activeInnerTab == "WALK" ? <Typography sx={{ fontSize: 15 }}>
                    <DirectionsWalkIcon
                      sx={{ fontSize: "18px", color: colors.cyan[600] }}
                    />  <span>  {cost2},{speed2}min</span>
                    </Typography>:null}
                   
        
        {/* {coordinates.sourceName} to {coordinates.targetName} <span style={{paddingRight:"40px",color:"#00acc1"}}>{cost1}km,{speed1}min</span> */}


      </CardContent>
      <CardActions>
      {/* <span  size="small" style={{color:"#00acc1"}} onClick={() => setState(true)}>Details</span> */}
      </CardActions>
    </React.Fragment>
  );


  return (
    <Box sx={{ minWidth: 200 }}>
      {state ? <RouteDetails state={state} setState={setState}/> : null}
      {feature1 ?<Card variant="outlined">{card}</Card> : null}
      {feature2 ? <Card variant="outlined">{secondCard}</Card>: null}
       {/* {feature3 ? <Card variant="outlined">{thirdCard}</Card>: null} */}
    </Box>
  );
};
